import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "@mui/material/Button";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import FormControl from "@mui/material/FormControl";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@mui/material/TextField";
import Modal from "@mui/material/Modal";
import GridItemLogin from "components/Grid/GridItemLogin.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeadertab.js";
import CloseIcon from "@mui/icons-material/Close";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import styles from "assets/jss/material-dashboard-react/components/tableviewStyle.js";
const useStyles = makeStyles(styles);
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import Config from "conFig.js";
import { NumericFormat } from "react-number-format";
import { Error, Success } from "../../assets/jss/util/messageUtil";
import { isLessThanDay } from "../../assets/jss/util/validateUtil";

const CapnhatgiayVT = React.memo(function CapnhatgiayVT(props) {
  const { giayvantai_id } = props;
  const classes = useStyles();
  const [phuongtien, setPhuongtien] = React.useState([]);
  const [phuongtien_id, setPhuongtien_id] = React.useState(null);
  const [laixe, setLaixe] = React.useState([]);
  const [laixevalue, setLaixevalue] = React.useState([]);
  const [sogiayvantai, setSogiayvantai] = React.useState("");
  const [ngayhethan, setNgayhethan] = React.useState(dayjs());
  const [tennguoithue, setTennguoithue] = React.useState("");
  const [diachinguoithue, setDiachinguoithue] = React.useState("");
  const [sohopdong, setSohopdong] = React.useState("");
  const [ngayhopdong, setNgayhopdong] = React.useState(dayjs());
  const [tuyenvanchuyen, setTuyenvanchuyen] = React.useState("");
  const [diemxephang, setDiemxephang] = React.useState("");
  const [diemgiaohang, setDiemgiaohang] = React.useState("");
  const [tg_xephang, setTg_xephang] = React.useState(dayjs());
  const [tg_giaohang, setTg_giaohang] = React.useState(dayjs());
  const [quangduong, setQuangduong] = React.useState(0);
  const [tenhanghoa, setTenhanghoa] = React.useState("");
  const [khoiluonghanghoa, setKhoiluonghanghoa] = React.useState(0);
  const [hanghoathongtinkhac, setHanghoathongtinkhac] = React.useState("");
  const [ngaygiayvantai, setNgaygiayvantai] = React.useState(dayjs());
  const [xh1_diadiem, setXh1_diadiem] = React.useState("");
  const [xh1_khoiluong, setXh1_khoiluong] = React.useState(0);
  const [xh1_thoigian, setXh1_thoigian] = React.useState(null);
  const [xh2_diadiem, setXh2_diadiem] = React.useState("");
  const [xh2_khoiluong, setXh2_khoiluong] = React.useState(0);
  const [xh2_thoigian, setXh2_thoigian] = React.useState(null);
  const [dh1_diadiem, setDh1_diadiem] = React.useState("");
  const [dh1_khoiluong, setDh1_khoiluong] = React.useState(0);
  const [dh1_thoigian, setDh1_thoigian] = React.useState(null);
  const [dh2_diadiem, setDh2_diadiem] = React.useState("");
  const [dh2_khoiluong, setDh2_khoiluong] = React.useState(0);
  const [dh2_thoigian, setDh2_thoigian] = React.useState(null);
  const [alert, setAlert] = React.useState(false);
  //const [alert1, setAlert1] = React.useState(false);
  const [alert2, setAlert2] = React.useState(false);
  const [alertValidate, setAlertValidate] = React.useState(false);
  const [messageValidate, setMessageValidate] = React.useState("");
  //const [disableBT, setDisableBT] = React.useState(false);
  const [openxephang, setOpenxephang] = React.useState(false);
  const [opendohang, setOpendohang] = React.useState(false);
  const handleClosexephang = () => {
    setOpenxephang(false);
  };
  const handleClosedohang = () => {
    setOpendohang(false);
  };
  const token = localStorage.getItem("token");
  var username = localStorage.getItem("username");
  var obj = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };
  const getgiayvantaitheoid = () => {
    var url =
      Config.backend +
      "/api/CoSoGTVT/getgiayvantaitheoid?giayvantai_id=" +
      giayvantai_id +
      "&username=" +
      username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setSogiayvantai(data[0].sogiayvantai);
        let [day, month, year] = data[0].ngayhethan.split("/");
        setNgayhethan(dayjs(year + "-" + month + "-" + day));
        setTennguoithue(data[0].tennguoithue);
        if (data[0].diachinguoithue)
          setDiachinguoithue(data[0].diachinguoithue);
        setSohopdong(data[0].sohopdong);
        let [day1, month1, year1] = data[0].ngayhopdong.split("/");
        setNgayhethan(dayjs(year1 + "-" + month1 + "-" + day1));
        setTuyenvanchuyen(data[0].tuyenvanchuyen);
        setDiemxephang(data[0].diemxephang);
        setDiemgiaohang(data[0].diemgiaohang);
        setTg_xephang(dayjs(data[0].tg_xephang));
        setTg_giaohang(dayjs(data[0].tg_giaohang));
        setQuangduong(data[0].quangduong);
        setTenhanghoa(data[0].tenhanghoa);
        setKhoiluonghanghoa(data[0].khoiluonghanghoa);
        setHanghoathongtinkhac(data[0].hanghoathongtinkhac);
        let [day2, month2, year2] = data[0].ngaygiayvantai.split("/");
        setNgaygiayvantai(dayjs(year2 + "-" + month2 + "-" + day2));
        setPhuongtien_id({
          id: data[0].phuongtien_id,
          ten: data[0].bienkiemsoat,
        });
        if (data[0].xh1_diadiem) setXh1_diadiem(data[0].xh1_diadiem);
        if (data[0].xh1_khoiluong) setXh1_khoiluong(data[0].xh1_khoiluong);
        if (data[0].xh1_thoigian !== "N/A")
          setXh1_thoigian(dayjs(data[0].xh1_thoigian)); // fix value.isbefore is not a function error
        if (data[0].xh2_diadiem) setXh2_diadiem(data[0].xh2_diadiem);
        if (data[0].xh2_khoiluong) setXh2_khoiluong(data[0].xh2_khoiluong);
        if (data[0].xh2_thoigian !== "N/A")
          setXh2_thoigian(dayjs(data[0].xh2_thoigian)); // fix value.isbefore is not a function error
        if (data[0].dh1_diadiem) setDh1_diadiem(data[0].dh1_diadiem);
        if (data[0].dh1_khoiluong) setDh1_khoiluong(data[0].dh1_khoiluong);
        if (data[0].dh1_thoigian !== "N/A")
          setDh1_thoigian(dayjs(data[0].dh1_thoigian)); // fix value.isbefore is not a function error
        if (data[0].dh2_diadiem) setDh2_diadiem(data[0].dh2_diadiem);
        if (data[0].dh2_khoiluong) setDh2_khoiluong(data[0].dh2_khoiluong);
        if (data[0].dh2_thoigian !== "N/A")
          setDh2_thoigian(dayjs(data[0].dh2_thoigian)); // fix value.isbefore is not a function error
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const getphuongtien = () => {
    var url =
      Config.backend +
      "/api/Phuongtien/getphuongtientheouser?username=" +
      username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setPhuongtien(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const getlaixe = () => {
    var url =
      Config.backend + "/api/Donvi/getlaixetheouser?username=" + username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setLaixe(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const getlaixetheogiayvantai = () => {
    var url =
      Config.backend +
      "/api/CoSoGTVT/getlaixetheogiayvantai?giayvantai_id=" +
      giayvantai_id +
      "&username=" +
      username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        if (data.length > 0) {
          let defaultlaixe = [];
          data.map((row) => {
            defaultlaixe.push({
              id: row.id,
              ten: row.hoten,
            });
          });
          setLaixevalue(defaultlaixe);
        }
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const capnhatgiayvantai = () => {
    let mess = validateCapnhat();
    if (mess === Success.SC0001) {
      var ngayhd =
        ngayhopdong.$y +
        "-" +
        String(ngayhopdong.$M + 1).padStart(2, "0") +
        "-" +
        ngayhopdong.$D;
      var tgxep =
        tg_xephang.$y +
        "-" +
        String(tg_xephang.$M + 1).padStart(2, "0") +
        "-" +
        tg_xephang.$D +
        " " +
        tg_xephang.$H +
        ":" +
        tg_xephang.$m +
        ":00";
      var tggiao =
        tg_giaohang.$y +
        "-" +
        String(tg_giaohang.$M + 1).padStart(2, "0") +
        "-" +
        tg_giaohang.$D +
        " " +
        tg_giaohang.$H +
        ":" +
        tg_giaohang.$m +
        ":00";
      if (xh1_thoigian) {
        var tgxep1 =
          xh1_thoigian.$y +
          "-" +
          String(xh1_thoigian.$M + 1).padStart(2, "0") +
          "-" +
          xh1_thoigian.$D;
      }
      if (xh2_thoigian) {
        var tgxep2 =
          xh2_thoigian.$y +
          "-" +
          String(xh2_thoigian.$M + 1).padStart(2, "0") +
          "-" +
          xh2_thoigian.$D;
      }
      if (dh1_thoigian) {
        var tgdo1 =
          dh1_thoigian.$y +
          "-" +
          String(dh1_thoigian.$M + 1).padStart(2, "0") +
          "-" +
          dh1_thoigian.$D;
      }
      if (dh2_thoigian) {
        var tgdo2 =
          dh2_thoigian.$y +
          "-" +
          String(dh2_thoigian.$M + 1).padStart(2, "0") +
          "-" +
          dh2_thoigian.$D;
      }
      let laixethem = [];
      laixevalue.map((row) => {
        laixethem.push({ id: row.id });
      });
      var url = Config.backend + "/api/CoSoGTVT/capnhatgiayvantai";
      fetch(url, {
        method: "PUT",
        headers: {
          Accept: "application/json, text/plain",
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          id: giayvantai_id,
          sogiayvantai: sogiayvantai,
          ngayhethan: ngayhethan,
          phuongtien_id: phuongtien_id.id,
          tennguoithue: tennguoithue,
          diachinguoithue: diachinguoithue,
          sohopdong: sohopdong,
          ngayhopdong: ngayhd,
          tuyenvanchuyen: tuyenvanchuyen,
          diemxephang: diemxephang,
          diemgiaohang: diemgiaohang,
          tg_xephang: tgxep,
          tg_giaohang: tggiao,
          quangduong: quangduong,
          tenhanghoa: tenhanghoa,
          khoiluonghanghoa: khoiluonghanghoa,
          hanghoathongtinkhac: hanghoathongtinkhac,
          ngaygiayvantai: ngaygiayvantai,
          laixe: laixethem,
          xh1_diadiem: xh1_diadiem,
          xh1_khoiluong: xh1_khoiluong,
          xh1_thoigian: tgxep1,
          xh2_diadiem: xh2_diadiem,
          xh2_khoiluong: xh2_khoiluong,
          xh2_thoigian: tgxep2,
          dh1_diadiem: dh1_diadiem,
          dh1_khoiluong: dh1_khoiluong,
          dh1_thoigian: tgdo1,
          dh2_diadiem: dh2_diadiem,
          dh2_khoiluong: dh2_khoiluong,
          dh2_thoigian: tgdo2,
          username: username,
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data === 1) {
            showNotification();
          } else showNotification2();
        })
        .catch((error) => {
          console.error("Error fetching data: ", error);
        });
    } else {
      setMessageValidate(mess);
      showNotificationValidate();
    }
  };
  const showNotificationValidate = () => {
    setAlertValidate(true);
    setTimeout(function () {
      setAlertValidate(false);
    }, 6000);
  };
  const showNotification = () => {
    setAlert(true);
    setTimeout(function () {
      setAlert(false);
    }, 2000);
  };
  // const showNotification1 = () => {
  //   setAlert1(true);
  //   setTimeout(function () {
  //     setAlert1(false);
  //   }, 3000);
  // };
  const showNotification2 = () => {
    setAlert2(true);
    setTimeout(function () {
      setAlert2(false);
    }, 2000);
  };
  // const disablebutton = () => {
  //   if (
  //     sogiayvantai.trim().length > 0 &&
  //     sohopdong.trim().length > 0 &&
  //     tennguoithue.trim().length > 0
  //   ) {
  //     setDisableBT(false);
  //   } else {
  //     setDisableBT(true);
  //   }
  // };

  // React.useEffect(() => {
  //   disablebutton();
  // }, [sogiayvantai, sohopdong, tennguoithue]);
  const validateCapnhat = () => {
    // Kiem tra thoi gian xep hang va thoi gian giao hang
    if (isLessThanDay(tg_giaohang, tg_xephang)) {
      return Error.ER0041;
    }
    // Kiem tra cac truong bat buoc nhap
    if (sogiayvantai.trim() === "") {
      return Error.ER0042;
    }
    if (tennguoithue.trim() === "") {
      return Error.ER0043;
    }
    if (sohopdong.trim() === "") {
      return Error.ER0044;
    }
    if (!phuongtien_id || phuongtien_id.id === 0) {
      return Error.ER0045;
    }
    if (laixevalue.length == 0) {
      return Error.ER0046;
    }
    return Success.SC0001;
  };
  React.useEffect(() => {
    getgiayvantaitheoid();
    getlaixetheogiayvantai();
    getphuongtien();
    getlaixe();
  }, []);
  return (
    <div>
      <CardBody style={{ borderBottom: "1px solid #bbb" }}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={3}>
            <FormControl style={{ width: "100%", marginTop: 8 }}>
              <TextField
                label="Giấy vận tải số"
                variant="outlined"
                size="small"
                value={sogiayvantai}
                onChange={(event) => {
                  setSogiayvantai(event.target.value);
                }}
                InputLabelProps={{
                  sx: {
                    color: "red",
                  },
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={3}>
            <FormControl style={{ width: "100%", marginTop: 8 }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Có giá trị đến"
                  value={ngayhethan}
                  format="DD/MM/YYYY"
                  onChange={(newValue) => {
                    setNgayhethan(newValue);
                  }}
                  slotProps={{ textField: { size: "small" } }}
                  views={["day", "month", "year"]}
                  sx={{
                    "& .MuiInputBase-root": {
                      height: "35px",
                    },
                  }}
                />
              </LocalizationProvider>
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={3}>
            <FormControl style={{ width: "100%", marginTop: 8 }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Ngày giấy vận tải"
                  value={ngaygiayvantai}
                  format="DD/MM/YYYY"
                  onChange={(newValue) => {
                    setNgaygiayvantai(newValue);
                  }}
                  slotProps={{ textField: { size: "small" } }}
                  views={["day", "month", "year"]}
                  sx={{
                    "& .MuiInputBase-root": {
                      height: "35px",
                    },
                  }}
                />
              </LocalizationProvider>
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={3}>
            <FormControl style={{ width: "100%", marginTop: 8 }}>
              <Autocomplete
                freeSolo
                disableClearable
                size="small"
                value={phuongtien_id}
                options={phuongtien}
                getOptionSelected={(option, value) => option.id === value.id}
                getOptionLabel={(option) => option.ten || option.sodangky}
                onChange={(event, newValue) => {
                  setPhuongtien_id(newValue);
                }}
                onInputChange={(event, newInputValue, reason) => {
                  if (reason !== "reset") {
                    setPhuongtien_id(null);
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Chọn phương tiện"
                    InputLabelProps={{
                      sx: {
                        color: "red",
                      },
                    }}
                    InputProps={{
                      ...params.InputProps,
                      type: "search",
                      style: {
                        height: "35px",
                        paddingTop: "initial",
                      },
                    }}
                  />
                )}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={3}>
            <FormControl style={{ width: "100%", marginTop: 20 }}>
              <TextField
                label="Tên người thuê"
                variant="outlined"
                size="small"
                value={tennguoithue}
                onChange={(event) => {
                  setTennguoithue(event.target.value);
                }}
                InputLabelProps={{
                  sx: {
                    color: "red",
                  },
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={5}>
            <FormControl style={{ width: "100%", marginTop: 20 }}>
              <TextField
                label="Địa chỉ người thuê"
                variant="outlined"
                size="small"
                value={diachinguoithue}
                onChange={(event) => {
                  setDiachinguoithue(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
            <FormControl style={{ width: "100%", marginTop: 20 }}>
              <Autocomplete
                multiple
                freeSolo
                disableClearable
                size="small"
                value={laixevalue}
                options={laixe}
                getOptionSelected={(option, value) => option.id === value.id}
                getOptionLabel={(option) => option.ten || option.hoten}
                onChange={(event, newValue) => {
                  setLaixevalue(newValue);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Chọn lái xe"
                    InputLabelProps={{
                      sx: {
                        color: "red",
                      },
                    }}
                    InputProps={{
                      ...params.InputProps,
                      type: "search",
                      style: {
                        height: "35px",
                        paddingTop: "initial",
                      },
                    }}
                  />
                )}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={3}>
            <FormControl style={{ width: "100%", marginTop: 20 }}>
              <TextField
                label="Số hợp đồng"
                variant="outlined"
                size="small"
                value={sohopdong}
                onChange={(event) => {
                  setSohopdong(event.target.value);
                }}
                InputLabelProps={{
                  sx: {
                    color: "red",
                  },
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={3}>
            <FormControl style={{ width: "100%", marginTop: 20 }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Ngày hợp đồng"
                  value={ngayhopdong}
                  format="DD/MM/YYYY"
                  onChange={(newValue) => {
                    setNgayhopdong(newValue);
                  }}
                  slotProps={{ textField: { size: "small" } }}
                  views={["day", "month", "year"]}
                  sx={{
                    "& .MuiInputBase-root": {
                      height: "35px",
                    },
                  }}
                />
              </LocalizationProvider>
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
            <FormControl style={{ width: "100%", marginTop: 20 }}>
              <TextField
                label="Tuyến vận chuyển"
                variant="outlined"
                size="small"
                value={tuyenvanchuyen}
                onChange={(event) => {
                  setTuyenvanchuyen(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={2}>
            <FormControl style={{ width: "100%", marginTop: 20 }}>
              <NumericFormat
                label="Quãng đường"
                variant="outlined"
                size="small"
                value={quangduong}
                customInput={TextField}
                allowNegative={false}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={0}
                onValueChange={({ value }) => {
                  setQuangduong(value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={8}>
            <FormControl style={{ width: "100%", marginTop: 20 }}>
              <TextField
                label="Điểm xếp hàng"
                variant="outlined"
                size="small"
                value={diemxephang}
                onChange={(event) => {
                  setDiemxephang(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
            <FormControl style={{ width: "100%", marginTop: 20 }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Thời gian xếp hàng"
                  value={tg_xephang}
                  format="HH:mm DD/MM/YYYY"
                  onChange={(newValue) => {
                    setTg_xephang(newValue);
                  }}
                  slotProps={{ textField: { size: "small" } }}
                  sx={{
                    "& .MuiInputBase-root": {
                      height: "35px",
                    },
                  }}
                />
              </LocalizationProvider>
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={8}>
            <FormControl style={{ width: "100%", marginTop: 8 }}>
              <TextField
                label="Điểm giao hàng"
                variant="outlined"
                size="small"
                value={diemgiaohang}
                onChange={(event) => {
                  setDiemgiaohang(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
            <FormControl style={{ width: "100%", marginTop: 8 }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Thời gian giao hàng"
                  value={tg_giaohang}
                  format="HH:mm DD/MM/YYYY"
                  onChange={(newValue) => {
                    setTg_giaohang(newValue);
                  }}
                  slotProps={{ textField: { size: "small" } }}
                  sx={{
                    "& .MuiInputBase-root": {
                      height: "35px",
                    },
                  }}
                />
              </LocalizationProvider>
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={5}>
            <FormControl style={{ width: "100%", marginTop: 20 }}>
              <TextField
                label="Tên hàng hóa"
                variant="outlined"
                size="small"
                value={tenhanghoa}
                onChange={(event) => {
                  setTenhanghoa(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={2}>
            <FormControl style={{ width: "100%", marginTop: 20 }}>
              <NumericFormat
                label="Khối lượng"
                variant="outlined"
                size="small"
                value={khoiluonghanghoa}
                customInput={TextField}
                allowNegative={false}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={0}
                onValueChange={({ value }) => {
                  setKhoiluonghanghoa(value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={5}>
            <FormControl style={{ width: "100%", marginTop: 20 }}>
              <TextField
                label="Thông tin khác"
                variant="outlined"
                size="small"
                value={hanghoathongtinkhac}
                onChange={(event) => {
                  setHanghoathongtinkhac(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
            <FormControl style={{ width: "100%", marginTop: 10 }}>
              <Button
                color="success"
                variant="contained"
                onClick={() => setOpenxephang(true)}
                style={{ height: 35 }}
              >
                Thông tin xếp hàng
              </Button>
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
            <FormControl style={{ width: "100%", marginTop: 10 }}>
              <Button
                color="warning"
                variant="contained"
                onClick={() => setOpendohang(true)}
                style={{ height: 35 }}
              >
                Thông tin dỡ hàng
              </Button>
            </FormControl>
          </GridItem>
        </GridContainer>
      </CardBody>
      {/** fix css */}
      <CardFooter style={{ marginBottom: "40px" }}>
        <Button
          color="primary"
          variant="contained"
          //disabled={disableBT}
          onClick={capnhatgiayvantai}
        >
          Cập nhật
        </Button>
      </CardFooter>
      <GridContainer>
        <GridItem xs={12} sm={10} md={12}>
          <Modal
            open={openxephang}
            onClose={handleClosexephang}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <div>
              <GridContainer>
                <GridItemLogin xs={12} sm={12} md={4}></GridItemLogin>
                <GridItemLogin xs={12} sm={12} md={4}>
                  <Card>
                    <CardHeader color="primary" style={{ height: 10 }}>
                      <GridContainer>
                        <GridItem xs={12} sm={12} md={10}>
                          <FormControl
                            style={{ width: "100%", marginTop: "10px" }}
                          >
                            <h6
                              className={classes.cardTitleWhite}
                              style={{ marginTop: "-5px" }}
                            >
                              Thông tin xếp hàng hóa
                            </h6>
                          </FormControl>
                        </GridItem>
                        <GridItem xs={12} sm={12} md={1}></GridItem>
                        <GridItem xs={12} sm={12} md={1}>
                          <FormControl
                            style={{ width: "100%", marginTop: "1px" }}
                          >
                            <CloseIcon onClick={handleClosexephang} />
                          </FormControl>
                        </GridItem>
                      </GridContainer>
                    </CardHeader>
                    <CardBody>
                      <GridContainer>
                        <GridItem xs={12} sm={12} md={12}>
                          <FormControl
                            style={{ width: "100%", marginTop: "8px" }}
                          >
                            <TextField
                              label="Địa điểm xếp hàng lần 1"
                              variant="outlined"
                              size="small"
                              value={xh1_diadiem}
                              onChange={(event) => {
                                setXh1_diadiem(event.target.value);
                              }}
                              InputProps={{
                                style: {
                                  height: "35px",
                                },
                              }}
                            />
                          </FormControl>
                        </GridItem>
                        <GridItem xs={12} sm={12} md={5}>
                          <FormControl
                            style={{ width: "100%", marginTop: "8px" }}
                          >
                            <NumericFormat
                              label="Khối lượng"
                              variant="outlined"
                              size="small"
                              value={xh1_khoiluong}
                              customInput={TextField}
                              allowNegative={false}
                              thousandSeparator="."
                              decimalSeparator=","
                              decimalScale={0}
                              onValueChange={({ value }) => {
                                setXh1_khoiluong(value);
                              }}
                              InputProps={{
                                style: {
                                  height: "35px",
                                },
                              }}
                            />
                          </FormControl>
                        </GridItem>
                        <GridItem xs={12} sm={12} md={7}>
                          <FormControl
                            style={{ width: "100%", marginTop: "8px" }}
                          >
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DatePicker
                                label="Thời gian"
                                value={xh1_thoigian}
                                format="DD/MM/YYYY"
                                onChange={(newValue) => {
                                  setXh1_thoigian(newValue);
                                }}
                                slotProps={{ textField: { size: "small" } }}
                                sx={{
                                  "& .MuiInputBase-root": {
                                    height: "35px",
                                  },
                                }}
                              />
                            </LocalizationProvider>
                          </FormControl>
                        </GridItem>
                        <GridItem xs={12} sm={12} md={12}>
                          <FormControl
                            style={{ width: "100%", marginTop: "8px" }}
                          >
                            <TextField
                              label="Địa điểm xếp hàng lần 2"
                              variant="outlined"
                              size="small"
                              value={xh2_diadiem}
                              onChange={(event) => {
                                setXh2_diadiem(event.target.value);
                              }}
                              InputProps={{
                                style: {
                                  height: "35px",
                                },
                              }}
                            />
                          </FormControl>
                        </GridItem>
                        <GridItem xs={12} sm={12} md={5}>
                          <FormControl
                            style={{ width: "100%", marginTop: "8px" }}
                          >
                            <NumericFormat
                              label="Khối lượng"
                              variant="outlined"
                              size="small"
                              value={xh2_khoiluong}
                              customInput={TextField}
                              allowNegative={false}
                              thousandSeparator="."
                              decimalSeparator=","
                              decimalScale={0}
                              onValueChange={({ value }) => {
                                setXh2_khoiluong(value);
                              }}
                              InputProps={{
                                style: {
                                  height: "35px",
                                },
                              }}
                            />
                          </FormControl>
                        </GridItem>
                        <GridItem xs={12} sm={12} md={7}>
                          <FormControl
                            style={{ width: "100%", marginTop: "8px" }}
                          >
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DatePicker
                                label="Thời gian"
                                value={xh2_thoigian}
                                format="DD/MM/YYYY"
                                onChange={(newValue) => {
                                  setXh2_thoigian(newValue);
                                }}
                                slotProps={{ textField: { size: "small" } }}
                                sx={{
                                  "& .MuiInputBase-root": {
                                    height: "35px",
                                  },
                                }}
                              />
                            </LocalizationProvider>
                          </FormControl>
                        </GridItem>
                        <GridItem xs={12} sm={12} md={12}>
                          <FormControl style={{ width: "15%", marginTop: 20 }}>
                            <Button
                              color="primary"
                              variant="contained"
                              onClick={handleClosexephang}
                              style={{ height: "25px" }}
                            >
                              Đóng
                            </Button>
                          </FormControl>
                        </GridItem>
                      </GridContainer>
                    </CardBody>
                  </Card>
                </GridItemLogin>
                <GridItemLogin xs={12} sm={12} md={4}></GridItemLogin>
              </GridContainer>
            </div>
          </Modal>
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={12} sm={10} md={12}>
          <Modal
            open={opendohang}
            onClose={handleClosedohang}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <div>
              <GridContainer>
                <GridItemLogin xs={12} sm={12} md={4}></GridItemLogin>
                <GridItemLogin xs={12} sm={12} md={4}>
                  <Card>
                    <CardHeader color="primary" style={{ height: 10 }}>
                      <GridContainer>
                        <GridItem xs={12} sm={12} md={10}>
                          <FormControl
                            style={{ width: "100%", marginTop: "10px" }}
                          >
                            <h6
                              className={classes.cardTitleWhite}
                              style={{ marginTop: "-5px" }}
                            >
                              Thông tin dỡ hàng hóa
                            </h6>
                          </FormControl>
                        </GridItem>
                        <GridItem xs={12} sm={12} md={1}></GridItem>
                        <GridItem xs={12} sm={12} md={1}>
                          <FormControl
                            style={{ width: "100%", marginTop: "1px" }}
                          >
                            <CloseIcon onClick={handleClosedohang} />
                          </FormControl>
                        </GridItem>
                      </GridContainer>
                    </CardHeader>
                    <CardBody>
                      <GridContainer>
                        <GridItem xs={12} sm={12} md={12}>
                          <FormControl
                            style={{ width: "100%", marginTop: "8px" }}
                          >
                            <TextField
                              label="Địa điểm dỡ hàng lần 1"
                              variant="outlined"
                              size="small"
                              value={dh1_diadiem}
                              onChange={(event) => {
                                setDh1_diadiem(event.target.value);
                              }}
                              InputProps={{
                                style: {
                                  height: "35px",
                                },
                              }}
                            />
                          </FormControl>
                        </GridItem>
                        <GridItem xs={12} sm={12} md={5}>
                          <FormControl
                            style={{ width: "100%", marginTop: "8px" }}
                          >
                            <NumericFormat
                              label="Khối lượng"
                              variant="outlined"
                              size="small"
                              value={dh1_khoiluong}
                              customInput={TextField}
                              allowNegative={false}
                              thousandSeparator="."
                              decimalSeparator=","
                              decimalScale={0}
                              onValueChange={({ value }) => {
                                setDh1_khoiluong(value);
                              }}
                              InputProps={{
                                style: {
                                  height: "35px",
                                },
                              }}
                            />
                          </FormControl>
                        </GridItem>
                        <GridItem xs={12} sm={12} md={7}>
                          <FormControl
                            style={{ width: "100%", marginTop: "8px" }}
                          >
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DatePicker
                                label="Thời gian"
                                value={dh1_thoigian}
                                format="DD/MM/YYYY"
                                onChange={(newValue) => {
                                  setDh1_thoigian(newValue);
                                }}
                                slotProps={{ textField: { size: "small" } }}
                                sx={{
                                  "& .MuiInputBase-root": {
                                    height: "35px",
                                  },
                                }}
                              />
                            </LocalizationProvider>
                          </FormControl>
                        </GridItem>
                        <GridItem xs={12} sm={12} md={12}>
                          <FormControl
                            style={{ width: "100%", marginTop: "8px" }}
                          >
                            <TextField
                              label="Địa điểm dỡ hàng lần 2"
                              variant="outlined"
                              size="small"
                              value={dh2_diadiem}
                              onChange={(event) => {
                                setDh2_diadiem(event.target.value);
                              }}
                              InputProps={{
                                style: {
                                  height: "35px",
                                },
                              }}
                            />
                          </FormControl>
                        </GridItem>
                        <GridItem xs={12} sm={12} md={5}>
                          <FormControl
                            style={{ width: "100%", marginTop: "8px" }}
                          >
                            <NumericFormat
                              label="Khối lượng"
                              variant="outlined"
                              size="small"
                              value={dh2_khoiluong}
                              customInput={TextField}
                              allowNegative={false}
                              thousandSeparator="."
                              decimalSeparator=","
                              decimalScale={0}
                              onValueChange={({ value }) => {
                                setDh2_khoiluong(value);
                              }}
                              InputProps={{
                                style: {
                                  height: "35px",
                                },
                              }}
                            />
                          </FormControl>
                        </GridItem>
                        <GridItem xs={12} sm={12} md={7}>
                          <FormControl
                            style={{ width: "100%", marginTop: "8px" }}
                          >
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DatePicker
                                label="Thời gian"
                                value={dh2_thoigian}
                                format="DD/MM/YYYY"
                                onChange={(newValue) => {
                                  setDh2_thoigian(newValue);
                                }}
                                slotProps={{ textField: { size: "small" } }}
                                sx={{
                                  "& .MuiInputBase-root": {
                                    height: "35px",
                                  },
                                }}
                              />
                            </LocalizationProvider>
                          </FormControl>
                        </GridItem>
                        <GridItem xs={12} sm={12} md={12}>
                          <FormControl style={{ width: "15%", marginTop: 20 }}>
                            <Button
                              color="primary"
                              variant="contained"
                              onClick={handleClosedohang}
                              style={{ height: "25px" }}
                            >
                              Đóng
                            </Button>
                          </FormControl>
                        </GridItem>
                      </GridContainer>
                    </CardBody>
                  </Card>
                </GridItemLogin>
                <GridItemLogin xs={12} sm={12} md={4}></GridItemLogin>
              </GridContainer>
            </div>
          </Modal>
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="info"
            icon={AddAlert}
            message="Cập nhật thành công"
            open={alert}
            closeNotification={() => setAlert(false)}
            close
          />
        </GridItem>
        {/* <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="warning"
            icon={AddAlert}
            message="Thời gian giao hàng phải sau thời gian nhận hàng"
            open={alert1}
            closeNotification={() => setAlert1(false)}
            close
          />
        </GridItem> */}
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="warning"
            icon={AddAlert}
            message="Có lỗi trong quá trình cập nhật"
            open={alert2}
            closeNotification={() => setAlert2(false)}
            close
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="warning"
            icon={AddAlert}
            message={messageValidate}
            open={alertValidate}
            closeNotification={() => setAlertValidate(false)}
            close
          />
        </GridItem>
      </GridContainer>
    </div>
  );
});

CapnhatgiayVT.propTypes = {
  giayvantai_id: PropTypes.number,
};
export default CapnhatgiayVT;
